const func = ($target) => {
	window.loader.key("swiper", function () {
		var spv = $target.attr("data-kd-type") == "mod" ? 1 : 2;
		var productsSlider = new Swiper($target.find(".swiper-container"), {
			slidesPerView: 1,
			spaceBetween: 30,
			effect: "slide",
			navigation: {
				nextEl: $target.find(".swiper-button-next"),
				prevEl: $target.find(".swiper-button-prev"),
			},
			breakpointsInverse: true,
			breakpoints: {
				768: {
					slidesPerView: spv,
				},
				992: {
					slidesPerView: spv + 1,
				},
				1200: {
					slidesPerView: spv + 2,
				},
			},
			on: {
				init: function () {
					$target.find(".fade").addClass("show");
				},
			},
		});
	});
};

export default func;
